<template lang="pug">
section.LndWeDo
  .d-flex.--middle.__header.d-not-sm
    h2 What we do
    hr
    span Growing sales by more than 200%
  .__grid
    span.wetake(style="order: 0")
      Svgi.__icon(name="wedo-1")
      span(v-html="L[1]")
    span(style="order: 1")
      .__icon: Svgi(name="wedo-2")
      span(v-html="L[2]")
    span(style="order: 2")
      .__icon: Svgi(name="wedo-3")
      span(v-html="L[3]")
    //- .__row
    span.d-not-sm
    span.__line(style="order: 1")
    span.__line(style="order: 2")
    //- .__row
    span.wepart(style="order: 10")
      .__icon: Svgi(name="wedo-4")
      span(v-html="L[4]")
    span.__list.prima(style="order: 1", v-html="L[5]")
    span.__list(style="order: 2", v-html="L[6]")
</template>
<script>
import content from 'content';

export default {
  name: 'LndWeDo',
  inject: ['mq'],

  static: () => ({
    L: content.intro,
  }),
};

</script>
<style>
.LndWeDo {
  --line-h: 40px;
  line-height: 32px;

  .__header {
    --gap-h: 30px;

    height: 70px;
    margin-bottom: 80px;

    hr {
      height: 70px;
      border-left: 1px solid var(--sep-c);
    }
  }

  .__row,
  .__sm-bg {
    display: contents;
  }

  .__line {
    height: var(--line-h);

    border-left: 1px solid var(--sep-c);
  }

  .__list {
    font-size: 12px;
    line-height: 25px;

    opacity: .7;
  }

  .__grid > span { position: relative; }

  .__icon {
    position: absolute;
    top: 8px;
    left: 0;

    display: flex;
    align-items: center;
    justify-content: center;

    width: 50px;
    height: 50px;
  }
}

@media (min-width: 740px) {
  .LndWeDo .__grid {
    display: grid;
    /*grid-auto-rows: minmax(10px, auto-fit);*/
    grid-template-rows: auto auto var(--line-h) auto;
    grid-template-columns: repeat(3, 1fr);
    gap: calc(48 / var(--vw-scale)) calc(44 / var(--vw-scale));
    margin-bottom: calc(48 / var(--vw-scale));

    > span {
      padding-left: 70px;
    }

    .__line { margin-left: 70px }

    > * { order: unset !important; }
  }
}

@media (max-width: 739px) {
  .LndWeDo .__grid {
    display: flex !important;
    flex-direction: column;
    padding-left: 100px !important;

    .__icon {
      left: -80px;
    }

    > span {
      display: block;
      margin-bottom: 30px;
      /*margin-left: 100px;*/
    }

    /*.__sm-bg {*/
    &,
    > .__row:first-child {
      display: block;
      /*background-color: var(--bg2);*/

      width: calc(100% + var(--page-pad) * 2);
      margin: 0 calc(-1 * var(--page-pad));
      padding: 0 var(--page-pad);
    }

    /*margin-top: calc(-1 * var(--page-pad));*/

    > .__row:first-child {
      display: block;
      margin-top: calc(-1 * var(--page-pad)) !important;
      /*background-color: var(--bg) !important;*/
    }

    .__row:first-child {
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      min-height: calc(100vh - var(--topb-h) - var(--page-pad));
      margin-bottom: 70px;
      padding-left: calc(100px + var(--page-pad));

      > * {
        margin-bottom: 100px;
      }
    }

    .wepart {
      margin-top: 50px;
      margin-bottom: 0;
    }
    .wetake,
    .prima { margin-bottom: 50px }
  }
}
</style>
